"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwColorPalette = _interopRequireDefault(require("./CwColorPalette.scss"));

var CwColorPalette =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwColorPalette, _React$Component);

  function CwColorPalette() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CwColorPalette);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CwColorPalette)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function (color) {
      if (_this.props.onClick) _this.props.onClick(color);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseDown", function () {
      if (_this.props.onMouseDown) _this.props.onMouseDown(true);
    });
    return _this;
  }

  (0, _createClass2.default)(CwColorPalette, [{
    key: "renderSwatch",
    value: function renderSwatch(color) {
      var _this2 = this;

      return _react.default.createElement("div", {
        key: color.name,
        "data-cwid": this.props.cwId + '_' + color.id,
        style: {
          backgroundColor: color.id
        },
        className: _CwColorPalette.default.swatch,
        onClick: function onClick() {
          _this2.handleClick(color);
        },
        onMouseDown: this.handleMouseDown
      });
    }
  }, {
    key: "renderSwatchRow",
    value: function renderSwatchRow(id, swatches) {
      return _react.default.createElement("div", {
        key: id
      }, swatches);
    }
  }, {
    key: "render",
    value: function render() {
      var colors = this.props.colors;
      var swatches = [];
      var swatchRows = [];
      var rowLength = 4; // Create grid of swatches

      for (var n = 1; n <= colors.length; n++) {
        swatches.push(this.renderSwatch(colors[n - 1]));

        if (n % rowLength === 0 || n === colors.length) {
          // Add a new row when rowLength reached
          swatchRows.push(this.renderSwatchRow(n, swatches));
          swatches = [];
        }
      }

      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        className: _CwColorPalette.default.colorPalette,
        style: this.props.style
      }, swatchRows);
    }
  }]);
  return CwColorPalette;
}(_react.default.Component);

CwColorPalette.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Callback function that is fired when dropdown is clicked.
   */
  onClick: _propTypes.default.func,

  /**
   * Callback function that is fired before onClick. Typically used to ignore blur in order to prevent dropdown from derezzing before a selection is registered.
   */
  onMouseDown: _propTypes.default.func,

  /**
   * Array of colors to be displayed in the color palette. "id" must be equal to the hex of the color. "name" is the text displayed in the trigger field.
   */
  colors: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    name: _propTypes.default.string
  })),

  /**
   * Set of style properties to determine the palette's position. Must contain left and top
   */
  style: _propTypes.default.shape({
    left: _propTypes.default.number,
    top: _propTypes.default.number
  })
};
var _default = CwColorPalette;
exports.default = _default;